/** Device buckets used by the web portals and their responsive UI. */
export type DeviceType = 'phone' | 'tablet' | 'pc';

/**
 * Keep these thresholds aligned with the portal CSS breakpoints:
 * phone < 768px, tablet 768–1023px, and PC >= 1024px.
 */
export function classifyDevice(viewportWidth: number): DeviceType {
  if (viewportWidth < 768) return 'phone';
  if (viewportWidth < 1024) return 'tablet';
  return 'pc';
}

